import React, { useState } from 'react';
import { isAuthenticated } from './auth';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import Generic from './view/generic';
import Report from './view/report';
import Login from './view/login';
import EsqueciSenha from './view/esqueci_senha';
import RecuperarSenha from './view/recuperar_senha';
import Home from './view/home';
import Classificacao from './view/classificacao';
import Carrinho from './view/carrinho';
import Noticias from './view/noticias';
import Favoritos from './view/favoritos';
import Informativos from './view/informativos';
import PagamentosPendente from './view/pagamentos_pendente';
import Pagamento from './view/pagamento';
import Produto from './view/produto';
import Pedido from './view/pedido';
import Swagger from './view/swagger';
import MeusDados from './view/meus_dados';
import MeusDadosRepresamentoAlteracao from './view/meus_dados_alteracao';
import MeusPedidos from './view/meus_pedidos';
import Promocoes from './view/promocoes';
import SqlExecute from './view/sql_execute';
import GerarCard from './view/gerar_card';
import Dashboard from './view/dashboard';
import DashboardTeste from './view/dashboard_teste';
import DashboardAdmCadastro from './view/dashboard_adm_cadastro';
import FluxoCliente from './view/fluxo_cliente';
import MinhaRede from './view/minha_rede';
import Consultor from './view/consultor';
import CredencialVirtual from './view/credencial_virtual';
import CredencialVirtualConsultor from './view/credencial_virtual_consultor';
import Formulario from './view/formulario';
import Component from './view/component';
import Notificacoes from './view/notificacoes';
import RelatorioConsultor from './view/relatorios/relatorio_consultor';
import MinhasEntrevistas from './view/minhas_entrevistas';
import VerEntrevista from './view/ver_entrevista';
import EntrevistaConsultor from './view/entrevista_consultor';
import RelatorioPontuacaoRede from './view/relatorios/relatorio_pontuacao_rede';
import RelatorioPontuacaoRedeAmericaLatina from './view/relatorios/relatorio_pontuacao_rede_america_latina';
import RelatorioPontuacaoFracionada from './view/relatorios/relatorio_pontuacao_fracionada_internacional';
import RelatorioAnaliseRiscoInatividade from './view/relatorios/relatorio_analise_risco_inatividade';
import RelatorioAscendenciaGenealogica from './view/relatorios/relatorio_ascendencia_genealogica';
import RelatorioBonusPeriodo from './view/relatorios/relatorio_bonus_periodo';
import RelatorioGraduacao from './view/relatorios/relatorio_graduacao';
import utils from './components/utils';
import RelatorioQualificacao from './view/relatorios/relatorio_qualificacao';
import RelatorioRankingDistribuidores from './view/relatorios/relatorio_ranking_distribuidores';
import RelatorioRankingDistribuidoresResumoMesPais from './view/relatorios/relatorio_ranking_distribuidores_resumo_mes_pais';
import RelatorioExtratoPontuacaoIndividualSintetico from './view/relatorios/relatorio_extrato_pontuacao_individual_sintetico';
import RelatorioExtratoPontuacaoIndividualAnalitico from './view/relatorios/relatorio_extrato_pontuacao_individual_analitico';
import RelatorioEventos from './view/relatorios/relatorio_eventos';
import RelatorioValidacaoRede from './view/relatorios/relatorio_validacao_rede';
import RelatorioConferenciaSpvGraduacaoPedido from './view/relatorios/relatorio_conferencia_spv_graduacao_pedido';
import RelatorioPontosVinculados from './view/relatorios/relatorio_pontos_vinculados';
import TrocarPai from './view/trocar_pai';
import TransferenciaMovimentacao from './view/transferencia_movimentacao';
import Evento from './view/evento';
import Eventos from './view/eventos';
import MapaPontos from './view/mapa_pontos';
import OcSPV from './view/ocspv';
import TesteRotinaGraduacao from './view/teste_rotina_graduacao';
import RelatorioValidacaoGraduacao from './view/relatorios/relatorio_validacao_graduacao';
import Contratos from './view/contratos';
import VerEntrevistaCliente from './view/ver_entrevista_cliente';
import LinksPagamentoPedido from './view/links_pagamento';
import ContratosPublico from './view/public/contratos_publico';
import BuscaRma from './view/relatorios/relatorio_rma';
import RelatorioApuracaoSpv from './view/relatorios/relatorio_apuracao_spv';
import RelatorioBonusIndividualPeriodo from './view/relatorios/relatorio_bonus_individual_periodo';
import SolicitarLoja from './view/solicitar_loja';
import SolicitarLojaConsultor from './view/solicitar_loja_consultor';
import Rankings from './view/rankings';
import MeusOrcamentos from './view/meus_orcamentos';
import Credenciamento from './view/credenciamento';
import Blog from './view/Blog';
import BlogTvNipponflex from './view/BlogTvNipponflex';
import BlogCampanhas from './view/Blog_campanhas';
import BlogAmericaLatina from './view/BlogAmericaLatina';
import Assinatura from './view/assinatura';
import PrepararContratos from './view/preparar_contratos';
import External from './view/external';
import TransmissaoAoVivo from './view/transmissao_ao_vivo';
import CampanhasPremiacaoCupons from './view/campanhas_premiacao_cupons';
import ClonagemCliente from './view/clonagem_cliente';
import CrudRedeDNA from './view/rede_dna';
import Test from './view/test';
import MemberkitEAD from './view/memberkit_ead';
import DowloadArquivosClientes from './view/download_arquivos_clientes';
import Faq from './view/Faq';
import LojaOnline from './view/loja_online';
import HistoricoComissao from './view/relatorios/pontos_saldo_spv_erp';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
      )
    }
  />
);

const Routes = function () {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route exact path="/esqueci_senha" component={EsqueciSenha} />
        <Route exact path="/recuperar_senha" component={RecuperarSenha} />
        <Route exact path="/welcome" component={RecuperarSenha} />
        <Route exact path="/test" component={Test} />
        <Route path="/public/contracts" component={ContratosPublico} />

        <PrivateRoute path="/fluxo/clientes" component={FluxoCliente} />
        <PrivateRoute path="/home" component={Home} />
        <PrivateRoute path="/faq/:faq_id" component={Faq} />
        <PrivateRoute path="/faq" component={Faq} />
        <PrivateRoute path="/dashboard" component={Dashboard} />
        <PrivateRoute path="/dashboard_teste" component={DashboardTeste} />
        <PrivateRoute path="/dashboard_adm_cadastro" component={DashboardAdmCadastro} />
        <PrivateRoute path="/noticias" component={Blog} />
        <PrivateRoute path="/news" component={BlogAmericaLatina} />
        <PrivateRoute path="/loja_online" component={LojaOnline} />
        <PrivateRoute path="/tv_nipponflex" component={BlogTvNipponflex} />
        <PrivateRoute path="/external/:name" component={External} />
        <PrivateRoute path="/campanhas" component={BlogCampanhas} />
        <PrivateRoute path="/crud" component={Generic} />
        <PrivateRoute path="/report/relatorio_pontuacao_rede" component={RelatorioPontuacaoRede} />
        <PrivateRoute
          path="/report/relatorio_pontuacao_rede_america_latina"
          component={RelatorioPontuacaoRedeAmericaLatina}
        />
        <PrivateRoute path="/report/relatorio_pontuacao_fracionada_internacional" component={RelatorioPontuacaoFracionada} />
        <PrivateRoute path="/report/relatorio_analise_risco_inatividade" component={RelatorioAnaliseRiscoInatividade} />
        <PrivateRoute path="/report/relatorio_ascendencia_genealogica" component={RelatorioAscendenciaGenealogica} />
        <PrivateRoute path="/report/relatorio_bonus_periodo" component={RelatorioBonusPeriodo} />
        <PrivateRoute
          path="/report/relatorio_extrato_pontuacao_individual_sintetico"
          component={RelatorioExtratoPontuacaoIndividualSintetico}
        />
        <PrivateRoute
          path="/report/relatorio_extrato_pontuacao_individual_analitico"
          component={RelatorioExtratoPontuacaoIndividualAnalitico}
        />
        <PrivateRoute path="/report/relatorio_graduacao" component={RelatorioGraduacao} />
        <PrivateRoute path="/report/relatorio_qualificacao" component={RelatorioQualificacao} />
        <PrivateRoute path="/report/relatorio_ranking_distribuidores" component={RelatorioRankingDistribuidores} />
        <PrivateRoute
          path="/report/relatorio_ranking_distribuidores_resumo_mes_pais"
          component={RelatorioRankingDistribuidoresResumoMesPais}
        />
        <PrivateRoute path="/report/relatorio_eventos" component={RelatorioEventos} />
        <PrivateRoute path="/report/relatorio_validacao_rede" component={RelatorioValidacaoRede} />
        <PrivateRoute
          path="/report/relatorio_conferencia_spv_graduacao_pedido"
          component={RelatorioConferenciaSpvGraduacaoPedido}
        />
        <PrivateRoute path="/report/relatorio_validacao_graduacao" component={RelatorioValidacaoGraduacao} />
        <PrivateRoute path="/report/relatorio_apuracao_spv" component={RelatorioApuracaoSpv} />
        <PrivateRoute path="/report/relatorio_bonus_individual_periodo" component={RelatorioBonusIndividualPeriodo} />
        <PrivateRoute path="/report/relatorio_pontos_vinculados" component={RelatorioPontosVinculados} />
        <PrivateRoute path="/report/pontos_saldo_spv_erp" component={HistoricoComissao} />
        <PrivateRoute path="/report" component={Report} />
        <PrivateRoute path="/produto/classificacao" component={Classificacao} />
        <PrivateRoute path="/carrinho/pagamento" component={Pagamento} />
        <PrivateRoute path="/carrinho/pedido" component={Pedido} />
        <PrivateRoute path="/carrinho/produto/" component={Produto} />
        <PrivateRoute path="/carrinho/favoritos" component={Favoritos} />
        <PrivateRoute path="/carrinho/promocoes" component={Promocoes} />
        <PrivateRoute path="/carrinho" component={Carrinho} />
        <PrivateRoute path="/meus_dados" component={MeusDados} />
        <PrivateRoute path="/meus_dados_alteracao" component={MeusDadosRepresamentoAlteracao} />
        <PrivateRoute path="/meus_pedidos" component={MeusPedidos} />
        <PrivateRoute path="/pagamentos_pendentes" component={PagamentosPendente} />
        <PrivateRoute path="/servicos/solicitar_loja" component={SolicitarLoja} />
        <PrivateRoute path="/servicos/solicitar_loja_consultor" component={SolicitarLojaConsultor} />
        <PrivateRoute path="/swagger" component={Swagger} />
        <PrivateRoute path="/minha_rede" component={MinhaRede} />
        <PrivateRoute path="/sql_execute" component={SqlExecute} />
        <PrivateRoute path="/gerar_card" component={GerarCard} />
        <PrivateRoute path="/consultores" component={Consultor} />
        <PrivateRoute path="/credencial_virtual" component={CredencialVirtual} />
        <PrivateRoute path="/credencial_virtual_consultor" component={CredencialVirtualConsultor} />
        <PrivateRoute path="/formulario" component={Formulario} />
        <PrivateRoute path="/component" component={Component} />
        <PrivateRoute path="/entrevistas/consultor/" component={EntrevistaConsultor} />
        <PrivateRoute path="/ver_entrevista" component={VerEntrevista} />
        <PrivateRoute path="/relatorios/consultor" component={RelatorioConsultor} />
        <PrivateRoute path="/entrevistas" component={MinhasEntrevistas} />
        <PrivateRoute path="/notificacoes" component={Notificacoes} />
        <PrivateRoute path="/clientes/trocar_pai" component={TrocarPai} />
        <PrivateRoute path="/clientes/transferencia_movimentacao" component={TransferenciaMovimentacao} />
        <PrivateRoute path="/ver_entrevista_cliente/:id" component={VerEntrevistaCliente} />
        <PrivateRoute path="/links_pagamento/:id" component={LinksPagamentoPedido} />
        <PrivateRoute path="/orcamentos_cliente/:id" component={MeusOrcamentos} />
        <PrivateRoute path="/evento/" component={Evento} />
        <PrivateRoute path="/informativos" component={Informativos} />
        <Route path="/contratos/:id_contrato/assinaturas/:id_cliente/:fase" component={Assinatura} />
        <PrivateRoute path="/contratos/preparar/:id_cliente" component={PrepararContratos} />
        <PrivateRoute path="/contratos" component={Contratos} />
        <PrivateRoute path="/eventos/credenciamento" component={Credenciamento} />
        <PrivateRoute path="/eventos" component={Eventos} />
        <PrivateRoute path="/ocspv" component={OcSPV} />
        <PrivateRoute path="/relatorios/busca_rma" component={BuscaRma} />
        <PrivateRoute path="/relatorios/mapa_pontos" component={MapaPontos} />
        <PrivateRoute path="/teste_rotina_graduacao" component={TesteRotinaGraduacao} />
        <PrivateRoute path="/rankings" component={Rankings} />
        <PrivateRoute path="/alterar_senha" component={RecuperarSenha} />
        <PrivateRoute path="/transmissao_ao_vivo" component={TransmissaoAoVivo} />
        <PrivateRoute path="/campanhas_premiacao_cupons" component={CampanhasPremiacaoCupons} />
        <PrivateRoute path="/clonagem_cliente" component={ClonagemCliente} />
        <PrivateRoute path="/rede_dna" component={CrudRedeDNA} />
        <PrivateRoute path="/memberkit_ead" component={MemberkitEAD} />
        <PrivateRoute path="/download_arquivos_clientes" component={DowloadArquivosClientes} />
        <PrivateRoute path="/" component={Home} />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
